import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { convertSecondsToTime } from 'utils/timeHelper';

import s from './style.module.scss';

import type { InteractiveTimeItem } from 'infrastructure/hooks/interactiveTimeDashboard/types';
import type { TableProps } from 'antd';

export const useColumns = (): TableProps<InteractiveTimeItem>['columns'] => {
  const { t } = useTranslation();

  return [
    {
      title: t('labels.patientName'),
      render: (_, record) => (
        <Link to={`/patient/${record.patient.guid}`} className={s.link}>
          {record.patient.fullName}
        </Link>
      ),
    },
    {
      title: t('labels.patientEmail'),
      render: (_, record) => <span>{record.patient.email}</span>,
    },
    {
      title: t('labels.clinicName'),
      render: (_, record) => <span>{record.clinic.name}</span>,
    },
    {
      title: t('labels.physician'),
      render: (_, record) => <span>{record.doctor.fullName}</span>,
    },
    {
      title: t('labels.ICD10Codes'),
      render: (_, record) => (
        <span>{record.patient.icdCodes?.join(', ') || '-'}</span>
      ),
    },
    {
      title: t('labels.totalRpmTime'),
      render: (_, record) => (
        <span>{convertSecondsToTime(record.actionTimes.total)}</span>
      ),
    },
    {
      title: t('labels.initialApcmAssessmentDate'),
      render: (_, record) => (
        <span>{record.patient.initialApcmAssessmentDate}</span>
      ),
    },
    {
      title: t('labels.monthlyApcmAssessmentDate'),
      render: (_, record) => (
        <span>{record.patient.monthlyApcmAssessmentDate}</span>
      ),
    },
  ];
};
